import { Box, Button, Container, Dialog, Grid, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import './testWithQuestion.css'
import Option from '../common/option';
import Question from '../common/question';
import Submit from "../../assets/images/Submit.png";
import Next from "../../assets/images/NextButton.png";
import Sad from "../../assets/images/Sad.png";
import Smile from "../../assets/images/Smile.png";
import LifeLine1 from "../../assets/images/LifeLine1.png";
import LifeLine2 from "../../assets/images/LifeLine2.png";
import LifeLine3 from "../../assets/images/LifeLine3.png";
import LifeLine4 from "../../assets/images/LifeLine4.png";
import LifeLine5 from "../../assets/images/LifeLine5.png";
import LifeLine6 from "../../assets/images/LifeLine6.png";
import axios from 'axios';
import { SAVE_ASSESSMENT } from '../../constants/apiContants';
import Copyright from '../common/copyright';
import Header from "../common/header";
import { Prompt, Redirect, Route } from 'react-router-dom';
import Confirmation from '../common/Confirmation';

var finishedTest = false


class TestWithQuestion extends Component {

    constructor(props) {
        super(props)
        this.aSelected = this.aSelected.bind(this);
        this.bSelected = this.bSelected.bind(this);
        this.cSelected = this.cSelected.bind(this);
        this.dSelected = this.dSelected.bind(this);

    }
    state = {
        minutes: 3,
        seconds: 0,
        index: 0,
        nextFlag: false,
        totalQuestion: 0,
        difficultTime: 0,
        moderateTime: 0,
        easyTime: 0,
        firstLifeLine: false,
        secondLifeLine: false,
        thirdLifeLine: false,
        questions: [],
        // correctAnswer: '',
        response: '',
        submit: false,
        next: false,
        responses: [],
        correctAnswer: [],
        fullCorrectAnswer: [],
        correctAnswerArray: [],
        correctFlag: false,
        randomIndex: [],
        leftIndex: -1,
        flipQuestion: false,
        fiftyFiftyFlag: false,
        fiftyFiftyDisabled: false,
        lifeLineUsed: false,
        correctCount: 0,
        saveQuesArray: [],
        flipDisabled: false,
        minutes_Counter: "00",
        seconds_Counter: "00",
        level: '',
        setPopup: false,
        askDidi: false,
        flipQues: false,
        fiftyFifty: false,
        confirmBox: false,
        askDisabled: false,
        saveFlag: false,
        finished: false
    }

    // static getDerivedStateFromProps(props, state) {
    //     console.log("props--", props)
    //     if (props.location.state == undefined) {
    //         props.history.push({
    //             pathname: "/"
    //         });
    //     }
    //     return null;
    // }

    componentDidMount() {
        if (this.props.location.state !== undefined) {
            console.log('In TestWithQuestion', this.props)
            // const location = useLocation();

            console.log(this.props.location.state)
            this.setState({
                questions: this.props.location.state.questions,
                minutes: this.props.location.state.assessmentDetails.timeLimit,
                totalQuestion: this.props.location.state.assessmentDetails.displayQuestionsCnt,
                difficultTime: this.props.location.state.assessmentDetails.level.Difficult,
                moderateTime: this.props.location.state.assessmentDetails.level.Moderate,
                easyTime: this.props.location.state.assessmentDetails.level.Easy,
                saveFlag: this.props.location.state.success
            })
            console.log('Level', this.props.location.state)
            this.generateRan(this.props.location.state.questions)
            this.setInterval();
            this.startTimer()
        }
    }

    startTimer() {
        let timer = setInterval(() => {
            var num = (Number(this.state.seconds_Counter) + 1).toString(),
                count = this.state.minutes_Counter;
            if (Number(this.state.seconds_Counter) == 59) {
                count = (Number(this.state.minutes_Counter) + 1).toString();
                num = '00';
            }
            this.setState({
                minutes_Counter: count.length == 1 ? '0' + count : count,
                seconds_Counter: num.length == 1 ? '0' + num : num,
            });
        }, 1000);
        // this.setState({timer});
        // this.setState({startDisable: true})
    }

    generateRan(quesArray) {
        // const { quesAndAns } = this.state
        var max = quesArray.length;
        console.log("in generate max", max)
        let length = this.props.location.state.assessmentDetails.displayQuestionsCnt;
        var random = []
        var allIndexes = []
        var leftIndexes = []
        var leftIndexAll = []
        for (var i = 0; i < length; i++) {
            var temp = Math.floor(Math.random() * max);
            if (random.indexOf(temp) == -1) {
                random.push(temp);
            }
            else
                i--;
        }
        for (var i = 0; i < max; i++) {
            var temp = Math.floor(Math.random() * max);
            if (allIndexes.indexOf(temp) == -1) {
                allIndexes.push(temp);

            }
            else
                i--;
        }
        leftIndexes = allIndexes.filter(function (obj) { return random.indexOf(obj) == -1; });
        var leftIndex = leftIndexes[Math.floor(Math.random() * leftIndexes.length)];

        console.log("all indexes in generate", allIndexes)
        console.log("RANDOM NUMBER in generate", random)
        console.log("left indexe NUMBER in generate", leftIndex)
        this.setState({ randomIndex: random, leftIndex: leftIndex })
    }

    setInterval() {
        this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    saveAssessment(data) {
        const { minutes_Counter, difficultTime, moderateTime, easyTime } = this.state
        var level = ""
        if (minutes_Counter >= 0 && minutes_Counter < difficultTime) {
            level = "Difficult"
        }
        else if (minutes_Counter >= 0 && minutes_Counter < moderateTime) {
            level = "Moderate"
        }
        else if (minutes_Counter >= 0 && minutes_Counter < easyTime) {
            level = "Easy"
        }

        console.log("data to be sent", data, "on", SAVE_ASSESSMENT);
        // data.preventDefault();
        axios.post(SAVE_ASSESSMENT, data)
            .then(response => {
                console.log(response)
                // this.setState({ data: response })
                // this.handlevalidation(response)
            }).catch(error => {
                console.log(error)
            })
        this.props.history.push({
            pathname: "/assessmentSummary",
            // search: "?query=abc",
            state: {
                assessmentDetails: this.props.location.state.assessmentDetails,
                studentDetails: this.props.location.state.studentDetails,
                testData: data,
                responseArray: this.state.responses,
                correctAnswerArray: this.state.correctAnswerArray,
                seconds: this.state.seconds,
                level: level
            },
        });
        // const history = useHistory()
        // this.props.history.push({ pathname: "/instructions", search: '?query=abc', state: {data: "OK"}})
    }

    renderBottomOptions() {
        const { nextFlag, index } = this.state
        if (nextFlag) {
            return (
                <NextButton
                    correctFlag={this.state.correctFlag}
                    onClick={() => { this.nextClicked() }}
                />
            )
        }
        else {
            return (
                <SubmitButton
                    onClick={() => this.submitClicked()}
                />
            )
        }
    }

    renderLifeLines() {
        const { firstLifeLine, secondLifeLine, thirdLifeLine,
            fiftyFiftyDisabled, flipDisabled, submit, askDisabled } = this.state
        if (!submit) {
            return (
                <LifeLines
                    onClick1={() => { this.setState({ askDidi: true, confirmBox: true }) }}
                    onClick2={() => { this.setState({ flipQues: true, confirmBox: true }) }}
                    onClick3={() => { this.setState({ fiftyFifty: true, confirmBox: true }) }}
                    // onClick1={() => { this.askSamparkDidi() }}
                    // onClick2={() => { this.flipTheQuestion() }}
                    // onClick3={() => { this.fiftyFifty() }}
                    firstCLicked={firstLifeLine}
                    secondCLicked={secondLifeLine}
                    thirdCLicked={thirdLifeLine}
                    disabled={fiftyFiftyDisabled}
                    flipDisabled={flipDisabled}
                    askDisabled={askDisabled}
                />
            )
        }
    }

    getCountofStar() {
        const { lifeLineUsed, minutes, difficultTime, moderateTime, easyTime, minutes_Counter } = this.state
        console.log('Times', difficultTime, moderateTime, easyTime, minutes_Counter)
        var starCount = 0
        if (!lifeLineUsed) {
            starCount = starCount + 1
        }
        if (minutes_Counter >= 0 && minutes_Counter < difficultTime) {
            starCount = starCount + 3
        }
        else if (minutes_Counter >= 0 && minutes_Counter < moderateTime) {
            starCount = starCount + 2
        }
        else if (minutes_Counter >= 0 && minutes_Counter < easyTime) {
            starCount = starCount + 1
        }
        return starCount
    }

    setSaveAssessment(starCount) {
        const { correctCount, totalQuestion, minutes, minutes_Counter } = this.state
        var setData = {
            "assessmentId": this.props.location.state.assessmentDetails.id,
            "studentId": this.props.location.state.studentDetails.id,
            "loggedInUserID": this.props.location.state.studentDetails.loggedInUserId,
            "stateId": this.props.location.state.studentDetails.state,
            "departmentId": this.props.location.state.studentDetails.deptId,
            "subjectId": this.props.location.state.assessmentDetails.subject,
            "correctQuesionCnt": correctCount,
            "totalQuesionCnt": totalQuestion,
            "entryType": "Calculated",
            "type": "MT",
            "sourceType": "web",
            "completionDuration": parseInt(minutes_Counter),
            "countOfStar": starCount,
            "questions": this.state.saveQuesArray,
            // "assessmentType": this.props.parentTestType
        }
        console.log('Data to be sent', JSON.stringify(setData))
        this.saveAssessment(setData)
    }

    submitTest() {
        const { responses, response, correctAnswer, index, randomIndex, difficultTime, moderateTime, easyTime,
            correctCount, totalQuestion, minutes_Counter, } = this.state
        var starCount = this.getCountofStar()
        this.setState({ finished: true })
        console.log("submitted", starCount, correctCount)
        var level = ""
        if (minutes_Counter >= 0 && minutes_Counter < difficultTime) {
            level = "Difficult"
        }
        else if (minutes_Counter >= 0 && minutes_Counter < moderateTime) {
            level = "Moderate"
        }
        else if (minutes_Counter >= 0 && minutes_Counter < easyTime) {
            level = "Easy"
        }
        if (this.state.saveFlag) {
            this.setSaveAssessment(starCount)
        }
        else {
            var data = {
                "assessmentId": this.props.location.state.assessmentDetails.id,
                // "studentId": this.props.location.state.studentDetails.id,
                // "loggedInUserID": this.props.location.state.studentDetails.loggedInUserId,
                // "stateId": this.props.location.state.studentDetails.state,
                // "departmentId": this.props.location.state.studentDetails.deptId,
                "subjectId": this.props.location.state.assessmentDetails.subject,
                "correctQuesionCnt": correctCount,
                "totalQuesionCnt": totalQuestion,
                "entryType": "Calculated",
                "type": "MT",
                "sourceType": "web",
                "completionDuration": parseInt(minutes_Counter),
                "countOfStar": this.getCountofStar(),
                "questions": this.state.saveQuesArray,
                // "assessmentType": this.props.parentTestType
            }
            var studentDetails = []
            if (this.props.location.state.studentDetails != undefined) {
                studentDetails = this.props.location.state.studentDetails
            }
            this.props.history.push({
                pathname: "/assessmentSummary",
                // search: "?query=abc",
                state: {
                    assessmentDetails: this.props.location.state.assessmentDetails,
                    studentDetails: studentDetails,
                    testData: data,
                    responseArray: this.state.responses,
                    correctAnswerArray: this.state.correctAnswerArray,
                    seconds: this.state.seconds,
                    level: level
                },
            });
        }
    }

    nextClicked() {
        const { nextFlag, index, totalQuestion } = this.state
        if (index == totalQuestion - 1) {
            this.setState({ finished: true })
            this.submitTest()
        }
        this.setState({
            nextFlag: false, index: index + 1, submit: false, next: true,
            response: '', fiftyFiftyFlag: false, flipQuestion: false
        })
        if (!this.state.secondLifeLine) {
            this.setState({ flipDisabled: false })
        }
    }

    setResponseArray() {
        const { minutes, seconds, index, firstLifeLine, secondLifeLine, thirdLifeLine,
            totalQuestion, responses, randomIndex, leftIndex, flipQuestion, response } = this.state
        var random
        if (flipQuestion) {
            random = leftIndex
        }
        else {
            random = randomIndex[index]
        }
        var ansText = ""
        let questionID = ""
        const correctAnswer = []
        const options = []
        this.state.questions.map(e => {
            questionID = e.id
            options.push(e.options)
            correctAnswer.push(e.correctAnswer)
            // console.log(e.correctAnswer)

        })
        for (var key in options[random]) {
            var value = options[random][key]
            console.log('id', questionID)
            // console.log('Value and keys are', correctAnswer[randomIndex[index]])
            if (response === "a") {
                ansText = value
            }
            else if (response === "b") {
                ansText = value
            }
            else if (response === "c") {
                ansText = value
            }
            else if (response === "d") {
                ansText = value
            }
            var respArray = {
                "id": questionID,
                "correctAnswer": correctAnswer[randomIndex[index]],
                "enteredAnswer": {
                    [response]: ansText
                }
            }

            console.log('respArray', this.state.saveQuesArray)
        }
        this.state.saveQuesArray.push(respArray)
    }

    // nextClicked() {
    //     const { nextFlag, index } = this.state
    //     this.setState({ nextFlag: false, index: index + 1, submit: false, next: true, response: '' })
    // }

    submitClicked() {
        const { responses, response, correctAnswer, index, randomIndex, correctCount, correctAnswerArray } = this.state
        if (response != "") {
            responses.push(response)
            correctAnswerArray.push(correctAnswer[randomIndex[index]])
            // console.log('correct Answer', correctAnswer[randomIndex[index]])
            { this.setState({ nextFlag: true, submit: true, next: false, }) }
            console.log("Responses", index, this.state.responses, correctAnswer[randomIndex[index]])
            if (response == correctAnswer[randomIndex[index]]) {
                this.setState({ correctFlag: true, correctCount: correctCount + 1 })
                console.log("Correct")
            }
            else {
                this.setState({ correctFlag: false })
                console.log("Incorrect")
            }
            this.setResponseArray()
        }
        else {
            this.setState({ setPopup: true })
            setInterval(() => {
                this.setState({ setPopup: false })
            }, 2000);
        }
    }

    aSelected() {
        this.setState({ response: 'a' })
        console.log("A selected")

    }

    bSelected() {
        this.setState({ response: 'b' })
        console.log("B selected")
    }

    cSelected() {
        this.setState({ response: 'c' })
        console.log("C selected")
    }

    dSelected() {
        this.setState({ response: 'd' })
        console.log("D selected")
    }

    askSamparkDidi() {
        this.setState({ firstLifeLine: true, lifeLineUsed: true })
        if (!this.state.secondLifeLine) {
            this.setState({ flipDisabled: true, askDisabled: true })
        }
    }

    flipTheQuestion() {
        this.setState({ secondLifeLine: true, flipQuestion: true, lifeLineUsed: true, flipDisabled: true })
    }

    fiftyFifty() {
        this.setState({ thirdLifeLine: true, fiftyFiftyFlag: true, fiftyFiftyDisabled: true, lifeLineUsed: true })
    }

    handleConfirmation() {
        const { askDidi, flipQues, fiftyFifty } = this.state
        this.setState({})
        if (askDidi) {
            this.askSamparkDidi()
        }
        else if (flipQues) {
            this.flipTheQuestion()
        }
        else if (fiftyFifty) {
            this.fiftyFifty()
        }
        this.setState({ askDidi: false, flipQues: false, fiftyFifty: false, confirmBox: false })
    }

    render() {
        const { minutes, seconds, index, firstLifeLine, secondLifeLine, thirdLifeLine, flipDisabled, fiftyFiftyDisabled,
            totalQuestion, responses, randomIndex, leftIndex, flipQuestion, fiftyFiftyFlag, confirmBox } = this.state
        var totalWidth = window.screen.width;
        const defaultProps = {
            bgcolor: "background.paper",
            m: 1,
            border: 1,
        };
        const questions = []
        const options = []
        const correctAnswer = []
        const questionsImage = []
        const optionsImage = []
        let answer = ""
        this.state.questions.map(e => {
            questions.push(e.question)
            questionsImage.push(e.question_image)
            options.push(e.options)
            optionsImage.push(e.options_image)
            correctAnswer.push(e.correctAnswer)
            // console.log(e.correctAnswer)

        })
        correctAnswer.map(item => {
            this.state.fullCorrectAnswer.push(item)
            for (var ans in item) {
                // console.log('answer', item)
                this.state.correctAnswer.push(ans)
                // this.setState({ correctAnswer: ans })
            }
        })
        for (var ans in correctAnswer[randomIndex[this.state.index]]) {
            // console.log('answer', ans)
            answer = ans
            // this.setState({ correctAnswer: ans })
        }
        var random
        if (flipQuestion) {
            random = leftIndex
        }
        else {
            random = randomIndex[index]
        }

        var studentName = ""
        var stateName = ""

        if (this.props.location.state != undefined && this.props.location.state.studentDetails != undefined) {
            studentName = this.props.location.state.studentDetails.name
            stateName = this.props.location.state.studentDetails.stateName
        }
        var images = optionsImage[random]
        console.log("images", images)
        var aImage = ""
        var bImage = ""
        var cImage = ""
        var dImage = ""
        if (images != undefined) {
            for (var key in images) {
                // console.log("Options",key,option[key])
                var value = images[key]
                if (key === "a") {
                    aImage = value
                }
                else if (key === "b") {
                    console.log(value)
                    bImage = value
                }
                else if (key === "c") {
                    cImage = value
                }
                else if (key === "d") {
                    dImage = value
                }
                // setAText(aTextValue)
                // Do stuff. ex: console.log(dict[key])
            }
        }
        //console.log("index is", random)
        const styles = useStyles
        return (
            <Route
                {...this.props}
                render={props =>
                    (this.props.location.state != undefined) ? (
                        <div className={styles.root}>
                            <Header
                                name={studentName}
                                className={this.props.location.state.assessmentDetails.className}
                                location={stateName}
                            />
                            {/* <Prompt
                                when={() => {
                                    const { index, totalQuestion } = this.state
                                    if (index < totalQuestion - 1) {
                                        return true
                                    }
                                    return false
                                }}
                                message="Are you sure you want to leave?"
                            /> */}
                            <Grid container
                                direction="row"
                                justify="center"
                                alignItems="center" spacing={3}>
                                <Grid item item xs={7} >
                                    <Box display="flex" alignItems="center">
                                        <Box minWidth={35}>
                                            {/* <Typography variant="body2" color="textSecondary">{`${Math.round(30

                                )}%`}</Typography> */}
                                        </Box>
                                        <Box width="100%" mr={1} alignItems="right">
                                            <Typography align="inherit">{index + 1}/{totalQuestion}</Typography>
                                            <ProgressBar
                                                percent={(index / totalQuestion) * 100}
                                                filledBackground="linear-gradient(to right, green, green)"

                                                width={totalWidth / 2}
                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item item xs={5}>
                                    <Typography variant="body2">{minutes === 0 && seconds === 0
                                        ? <Typography>Time Over!</Typography>
                                        : <Typography align="center" className={styles.timer}> Time Left: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</Typography>
                                    }</Typography>
                                </Grid>


                            </Grid>
                            <Container className={styles.topContainer}>
                                <Dialog open={this.state.setPopup} hideBackdrop >
                                    <Typography style={style.popup}>
                                        कृपया एक विकल्प चुनें
                                        </Typography>
                                </Dialog>
                                <Confirmation
                                    open={confirmBox}
                                    handleConfirmation={() => {
                                        this.handleConfirmation()
                                    }}
                                    handleClose={() => { this.setState({ confirmBox: false }) }}
                                />
                                <Box display="flex" justifyContent="center" marginTop={5} className="buttonContainer">

                                    <Box
                                        borderColor="grey.500"
                                        border={0.5}

                                        {...defaultProps}
                                        paddingY={2}
                                        boxShadow={3}
                                        width={window.innerWidth / 1.2}
                                    >
                                        <Question
                                            question={questions[random]}
                                            questionImage={questionsImage[random]}
                                        />
                                        <Option
                                            option={options[random]}
                                            aImage={aImage}
                                            bImage={bImage}
                                            cImage={cImage}
                                            dImage={dImage}
                                            optionImages={optionsImage[random]}
                                            selectedA={this.aSelected}
                                            selectedB={this.bSelected}
                                            selectedC={this.cSelected}
                                            selectedD={this.dSelected}
                                            correctAnswer={answer}
                                            isNextPressed={this.state.next}
                                            isSubmited={this.state.submit}
                                            firstLifeLine={firstLifeLine}
                                            secondLifeLine={secondLifeLine}
                                            fiftyFiftyDisabled={fiftyFiftyDisabled}
                                            thirdLifeLine={fiftyFiftyFlag}
                                        />

                                    </Box>
                                </Box>
                                {
                                    this.renderBottomOptions()
                                }
                                {this.renderLifeLines()}
                            </Container>
                            {/* <footer className={styles.footer}>
                    <Container maxWidth="sm">
                        <Copyright />
                    </Container>
                </footer> */}
                        </div>)
                        :
                        (
                            <Redirect to={{ pathname: '/' }} />
                        )
                }
            />



        );
    }
}

function LifeLines({ onClick1, onClick2, onClick3, firstCLicked, secondCLicked, thirdCLicked, disabled, flipDisabled, askDisabled }) {
    const classes = useStyles()

    function first() {
        if (firstCLicked) {
            return LifeLine1
        }
        else {
            return LifeLine4
        }
    }

    function second() {
        if (secondCLicked) {
            return LifeLine2
        }
        else {
            return LifeLine5
        }
    }

    function third() {
        if (thirdCLicked) {
            return LifeLine3
        }
        else {
            return LifeLine6
        }
    }

    function FormRow() {
        return (
            <Grid container
                direction="row"
                justify="center"
                alignItems="center">
                <Grid item xs={4} container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Button disabled={askDisabled}
                        type="submit"
                        variant="text"
                        className={classes.submit}
                        onClick={onClick1}>
                        <img className="lifeLine" src={first()} alt="start" />
                    </Button>
                </Grid>
                <Grid item xs={4} container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Button disabled={flipDisabled}
                        type="submit"
                        variant="text"
                        className={classes.submit}
                        onClick={onClick2}>
                        <img className="lifeLine" src={second()} alt="start" />
                    </Button>
                </Grid>
                <Grid item xs={4} container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Button
                        disabled={disabled}
                        type="submit"
                        variant="text"
                        className={classes.submit}
                        onClick={onClick3}>
                        <img className="lifeLine" src={third()} alt="start" />
                    </Button>
                </Grid>
            </Grid>
        );
    }
    return (
        <Grid container
            direction="row"
            justify="center"
            alignItems="center" >
            <Grid container
                direction="row"
                justify="center"
                alignItems="center">
                <FormRow />
            </Grid>
        </Grid>
    )
}

function SubmitButton({ onClick }) {
    const styles = useStyles()
    function MiddleAlign() {
        return (
            <Grid container spacing={1}>
                <Grid item container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Button
                        type="submit"
                        variant="text"
                        className={styles.submit}
                        onClick={onClick}
                    >
                        <img className="submitImage" src={Submit} alt="start" />
                    </Button>
                </Grid>
            </Grid>
        );
    }
    return (
        <div >
            <Grid container spacing={1}>
                <Grid container item xs={12}>
                    <MiddleAlign />
                </Grid>
            </Grid>
        </div>
    )
}

function NextButton({ onClick, correctFlag }) {
    const styles = useStyles()
    function showEmoji() {
        if (correctFlag) {
            return (
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center" spacing={3}>
                    <Grid item >
                        <img src={Smile} className={styles.emoji} />
                    </Grid>
                    <Grid item >
                        <Typography align="center" className={styles.emojiTextPositive}> Wow! You did it!!</Typography>
                    </Grid>
                </Grid>
            )
        }
        else {
            return (
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center" spacing={3}>
                    <Grid item >
                        <img src={Sad} className={styles.emoji} />
                    </Grid>
                    <Grid item >
                        <Typography align="center" className={styles.emojiTextNegative}> Oh no! keep going!</Typography>
                    </Grid>
                </Grid>
            )
        }
    }
    function MiddleAlign() {
        return (
            <Grid container spacing={1}>

                <Grid item container
                    direction="column"
                    justify="center"
                    alignItems="center">
                    {showEmoji()}
                    <Button
                        type="submit"
                        variant="text"
                        className={styles.submit}
                        onClick={onClick}
                    >
                        <img className="submitImage" src={Next} alt="start" />
                    </Button>
                </Grid>

            </Grid>
        );
    }
    return (
        <div >
            <Grid container spacing={1}>
                <Grid container item xs={12}>
                    <MiddleAlign />
                </Grid>
            </Grid>
        </div>
    )
}

export default TestWithQuestion;


const useStyles = makeStyles((theme) => ({

    root: {
        display: "flex",
        flexDirection: 'column',
        minHeight: '100vh',
    },
    paper: {
        maxWidth: 800,
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2)
    },
    emoji: {
        alignSelf: 'center',
        height: 40
    },
    paper2: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        backgroundImage: {}
    },
    qImage: {
        alignSelf: 'center'
    },

    content: {
        color: 'red'
    },
    topContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    timer: {
        textColor: 'green',
        fontSize: '12px',
    },
    timerLabel: {
        fontSize: '12px'
    },
    quesContainer: {
        padding: 5,
        // width: window.screen.availWidth/2,
        borderWidth: 1,
        borderRadius: 10,
        alignSelf: 'center',
        borderColor: 'black',
        marginTop: 1,
        marginBottom: 15,
        // flex: 1
    },
    popup: {
        padding: 20,
        backgroundColor: 'rgba(0, 253, 0, 0.5)'
    },
    progress: {
        marginTop: '10vh'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        //margin: theme.spacing(3, 0, 2),
        alignContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        justifySelf: 'center',
        justifyItems: 'center',

        // backgroundImage: `url(${start})`,
        // backgroundRepeat
        // flex: 1,
        // height: 40
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
    },
    emojiTextPositive: {
        color: 'green',
        fontSize: 15,
        fontWeight: '800'
    },
    emojiTextNegative: {
        color: 'red',
        fontSize: 15,
        fontSize: 15,
        fontWeight: '800'
    }

}));

const style = {
    popup: { padding: 20, backgroundColor: 'rgba(0, 253, 0, 0.5)' }
}